<top-menu [showPrint]="true" [showFilter]="true" (filter)="filter()" [filtered]="!!actualFilterCount">
  <div class="top-menu-mid-right">
    <icon [icon]="'grow'"  (click)="$event.stopPropagation(); expandAll()"></icon>
    <icon [icon]="'shrink'" (click)="$event.stopPropagation(); collapseAll()"></icon>
    <icon-text [text]="'Display Options'" [active]="!!excludedFieldIds.length" [icon]="null" (click)="editDisplayOptions()"></icon-text>
  </div>
</top-menu>
<mobile-menu></mobile-menu>
<loader-pane-fragment [trace]="traceNames.viewLogisticsViews"></loader-pane-fragment>
<joi-nav-wrapper
  class="view-mode-tabs"
  [menuItems]="viewModes"
  [menuMap]="viewModeNames"
  [selectedId]="selectedViewMode" 
  (selectItem)="changeView($event)"
> </joi-nav-wrapper>
<logistics-view #logisticsView *ngIf="programsLoaded && programs?.length !== 0 && !!currentEvent"
  [logisticsEvent]="currentEvent"
  [canViewStagingRequests]="!is_logistics"
  [programs]="programs"
  [program_labels]="labelMaps.program_labels"
  [session_labels]="labelMaps.session_labels"
  [excludedFieldIds]="excludedFieldIds"
  [exhibitorStandIdsByProgramId]="exhibitorStandIdsByProgramId"
  [tagDataMap]="tagDataMap"
  [sessionMap]="sessionMap"
></logistics-view>